import React from "react";

import { largeScreen } from "src/shared/constants/screenSizes";
import { useIsMobile } from "src/shared/utilities/customHooks";

import HeaderNavLink from "../../HeaderNavLink";

const PropertyManager = () => {
  const isMobile = useIsMobile(largeScreen);

  return (
    <>
      <HeaderNavLink href="/property-manager">Property Manager</HeaderNavLink>
      {!isMobile && (
        <HeaderNavLink
          data-gtm-header-menu="Property Manager"
          href="/user/logout"
        >
          Sign Out
        </HeaderNavLink>
      )}
    </>
  );
};

export default PropertyManager;
